import React from 'react';
export class Inform extends React.Component {

    render() {

        return (<div><form>
            <div>
                {"error" in this.props.serverResponse &&
                    <div id="errors-container">
                        {this.props.serverResponse.error.map((elem, idx) => <span className="error" key={idx}>{elem}</span>)}
                    </div>
                }
                {("inform" in this.props.serverResponse) &&
                    this.props.serverResponse.inform.map((elem, idx) => <span className="error" key={idx}>{elem}</span>)}

                <button onClick={window.location.reload}> Voltar </button>
            </div>
        </form></div>);
    }
}
